// src/components/layout/sidebar.data.ts
import { IconType } from 'react-icons';
import { FiHome, FiUsers, FiList } from 'react-icons/fi';
import { FaSearch, FaSearchPlus, FaCog, FaFlask } from 'react-icons/fa';

export interface MenuItemType {
  path: string;
  icon: IconType;
  name: string;
  children?: MenuItemType[];
}

export const menuItems: MenuItemType[] = [
  { path: '/inicio', icon: FiHome, name: 'Inicio' },
  { path: '/reportes', icon: FaFlask, name: 'Reportes' },
  { path: '/usuarios', icon: FiUsers, name: 'Usuarios' },
  { path: '/consulta-activos', icon: FaSearch, name: 'Consulta de envases' },
  { path: '/auditrail', icon: FaSearchPlus, name: 'Auditrail' },
  { path: '/catalogos', icon: FiList, name: 'Catalogos' },
  { path: '/configuracion', icon: FaCog, name: 'Configuración' },
];
